import tpl from "./suggestedListings.html";

/**
 *
 * show suggested listings
 *
 * always works for a client or anonymous or agent
 *
 **/
/* @ngInject */
export function moreLikeThis(ajaxviews, $window, Analytics, $timeout) {
  return {
    templateUrl: tpl,
    scope: {},
    link: function($scope, $element, $attr) {
      ajaxviews.get(
        "similar_to",
        {
          num: $attr.num || 8,
          id: $attr.id
        },
        $scope
      );

      $scope.goto = function($event, apt) {
        Analytics.track("clicked-suggested-listing", {
          apt: apt.id
        });
        // wait for analytics to send
        $timeout(function() {
          if ($event.metaKey) {
            $window.open("/" + apt.id);
          } else {
            $window.location.href = "/" + apt.id;
          }
        }, 150);
      };
    }
  };
}
